module.exports = {"450323100":"灵川镇","450323101":"大圩镇","450323102":"定江镇","450323103":"三街镇","450323104":"潭下镇","450323106":"九屋镇","450323107":"灵田镇","450323200":"潮田乡","450323201":"大境瑶族乡","450323202":"海洋乡","450323206":"兰田瑶族乡","450323207":"公平乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450323.json
// module id = 2099
// module chunks = 0